//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_ASESORES_RESPONSABLES = "obtenerAsesoresResponsables";
export const OBTENER_ASESOR_RESPONSABLE = "obtenerAsesorResponsable";
// mutation types
export const SET_ASESORES_RESPONSABLES = "setAsesoresResponsables";
export const SET_ASESOR_RESPONSABLE = "setAsesorResponsable";

const state = {
    asesores: [],
    asesor:[],
}

const getters = {
    obtenerAsesoresResponsables(state) {
      return state.asesores;
    },
}

const actions = {
    async [OBTENER_ASESORES_RESPONSABLES](context, estadoId) {

        /*
        * Si el estado es null va a traer a todos los usuarios, de lo contrario va a traer los usuarios por estado
        *
        */
        let endpoint = 'api/Usuario';
        if(estadoId){
            endpoint = `api/Usuario/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_ASESORES_RESPONSABLES, data.data);
                    //console.log(data.data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_ASESOR_RESPONSABLE](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_ASESOR_RESPONSABLE, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    }
  }

const mutations = {
    [SET_ASESORES_RESPONSABLES](state, data) {
        state.asesores = data;
    },

    [SET_ASESOR_RESPONSABLE](state, data) {
        state.asesor = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}